"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInviteComponent = void 0;
var tslib_1 = require("tslib");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var submit_button_1 = require("../../components/submit.button");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var auth_component_style_1 = require("../auth/auth.component.style");
var signup_1 = require("../signup/signup");
var signup_ctrl_1 = require("../signup/signup.ctrl");
var accept_invite_ctrl_1 = require("./accept.invite.ctrl");
var CSS = {
    container: 'c-AcceptInvite',
    footer: 'c-AcceptInvite__footer',
    textSeparator: 'c-AcceptInvite_TexSeparator'
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        display: 'flex',
        'flex-direction': 'column',
        '& > .mdl-button': {
            width: '300px',
            padding: '0'
        },
        'box-sizing': 'border-box',
        'max-width': '100%',
        width: '330px', // This is needed so IE will wrap text
        'align-items': 'center;'
    },
    _a[CSS.textSeparator] = {
        margin: theme_1.DefaultTheme.space(4),
        color: theme_1.DefaultTheme.font.color.supporting,
        'align-self': 'stretch',
        'text-align': 'center'
    },
    _a[CSS.footer] = {
        padding: '20px 0',
        'text-align': 'right',
        width: '100%',
        '& a': {
            cursor: 'pointer',
            'text-decoration': 'none',
            color: theme_1.DefaultTheme.color.accent,
            'font-weight': 500
        }
    },
    _a));
var AcceptInviteComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AcceptInviteComponent, _super);
    function AcceptInviteComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        _this.loggedInComponent = new LoggedInComponent(_this.ctrl);
        _this.chooseComponent = new InviteChooseMethodComponent(_this.ctrl);
        var signupCtrl = new signup_ctrl_1.SignupCtrl(function (success) { return _this.acceptNewSSOUser(!!success); });
        _this.successSSOComponent = new InviteSuccessSSOComponent(_this.ctrl);
        _this.failedSSOComponent = new InviteFailedSSOComponent(_this.ctrl);
        _this.invalidAccountComponent = new InviteInvalidAccountComponent(_this.ctrl);
        if (services_1.Services.SSO.isAuthenticated) {
            _this.checkValidEmail();
        }
        /**
         * We don't need a login CTRL or component here as after the user is redirected to Auth0 for login
         *  they come back with no page state so they will follow the same flow as if they were already authenticated
         * */
        _this.signupComponent = new signup_1.Signup(signupCtrl, _this.ctrl.inviteToken);
        _this.acceptInviteComponent = new InviteAcceptComponent(_this.ctrl);
        return _this;
    }
    AcceptInviteComponent.prototype.onCreate = function () {
        this.ctrl.validateInviteToken();
    };
    Object.defineProperty(AcceptInviteComponent.prototype, "component", {
        get: function () {
            if (services_1.Services.SSO.isAuthenticated) {
                if (this.ctrl.validEmail) {
                    return this.acceptInviteComponent;
                }
                else {
                    return this.invalidAccountComponent;
                }
            }
            else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.LoggedIn) {
                return this.loggedInComponent;
            }
            else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.Login) {
                return this.loginComponent;
            }
            else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.Signup) {
                return this.signupComponent;
            }
            else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.Success) {
                return this.acceptInviteComponent;
            }
            else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.SuccessSSO) {
                return this.successSSOComponent;
            }
            else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.FailedSSO) {
                return this.failedSSOComponent;
            }
            return this.chooseComponent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AcceptInviteComponent.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('form', { className: CSS.container }, [
                (0, mithril_1.m)('h3', (0, index_1.Translate)(index_1.T.INVITE_ACCEPT_TITLE)),
                !this.ctrl.awaitingCheck ? this.component.view() : spinner_1.Spinner.view()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    AcceptInviteComponent.prototype.acceptNewSSOUser = function (success) {
        if (success) {
            this.ctrl.inviteNewSSOUser();
        }
        else {
            this.ctrl.failedNewSSOUser();
        }
    };
    AcceptInviteComponent.prototype.checkValidEmail = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.ctrl.awaitingCheck = true;
                        _b = (_a = this.ctrl).setValidEmail;
                        return [4 /*yield*/, services_1.Services.Department.Invite.checkEmail(this.ctrl.inviteToken, services_1.Services.SSO.user.email)];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        this.ctrl.awaitingCheck = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return AcceptInviteComponent;
}(mithril_component_1.IMithrilStateComponent));
exports.AcceptInviteComponent = AcceptInviteComponent;
var LoggedInComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LoggedInComponent, _super);
    function LoggedInComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        return _this;
    }
    Object.defineProperty(LoggedInComponent.prototype, "nodes", {
        get: function () {
            var _this = this;
            return [
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, this.ctrl.user.username),
                submit_button_1.SubmitButton.view({
                    title: index_1.T.INVITE_ACCEPT_TITLE,
                    submit: function () { return _this.ctrl.inviteLoggedInUser(); },
                    submitting: this.ctrl.loading,
                    className: auth_component_style_1.CSS.button,
                    noAccent: true
                }),
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_TOKEN_OR)),
                submit_button_1.SubmitButton.view({
                    title: index_1.T.CANCEL,
                    submit: function () { return _this.ctrl.cancel(); },
                    submitting: this.ctrl.loading,
                    className: auth_component_style_1.CSS.button,
                    noAccent: true
                })
            ];
        },
        enumerable: false,
        configurable: true
    });
    return LoggedInComponent;
}(mithril_component_1.IMithrilStateComponent));
var InviteChooseMethodComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InviteChooseMethodComponent, _super);
    function InviteChooseMethodComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        return _this;
    }
    Object.defineProperty(InviteChooseMethodComponent.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (this.ctrl.loading) {
                return spinner_1.Spinner.view();
            }
            if (!this.ctrl.validatedToken) {
                return [
                    (0, mithril_1.m)('p', (0, index_1.Translate)(index_1.T.INVITE_TOKEN_INVALID)),
                    this.viewExitButton()
                ];
            }
            return [
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_LOGIN_HELP)),
                (0, mithril_1.m)('button', {
                    className: "mdl-button mdl-button--raised ".concat(auth_component_style_1.CSS.button),
                    onclick: function () {
                        services_1.Services.SSO.login({
                            redirect_uri: window.location.origin + services_1.Services.Route.getRouteURL(page_1.IkePageName.acceptInvite, { inviteToken: _this.ctrl.inviteToken })
                        });
                    }
                }, (0, index_1.Translate)(index_1.T.LOGIN_WITH_AUTH0)),
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_SIGNUP_HELP)),
                (0, mithril_1.m)('button', {
                    className: "mdl-button mdl-button--raised ".concat(auth_component_style_1.CSS.button),
                    onclick: function () { return _this.ctrl.setInviteMethod(accept_invite_ctrl_1.InviteMethod.Signup); }
                }, (0, index_1.Translate)(index_1.T.SIGNUP))
            ];
        },
        enumerable: false,
        configurable: true
    });
    InviteChooseMethodComponent.prototype.viewExitButton = function () {
        return (0, mithril_1.m)('a', {
            className: "mdl-button mdl-button--raised ".concat(auth_component_style_1.CSS.button),
            href: services_1.Services.Route.getRouteURL(page_1.IkePageName.root)
        }, (0, index_1.Translate)(index_1.T.CANCEL));
    };
    return InviteChooseMethodComponent;
}(mithril_component_1.IMithrilStateComponent));
var InviteAcceptComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InviteAcceptComponent, _super);
    function InviteAcceptComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        return _this;
    }
    Object.defineProperty(InviteAcceptComponent.prototype, "nodes", {
        get: function () {
            var _this = this;
            var successFunc = function () { return _this.ctrl.completeSSOInvite(); };
            var pageText = (0, index_1.Translate)(index_1.T.INVITE_VALID_PROMPT);
            var buttonText = index_1.T.ACCEPT;
            return [
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, pageText),
                submit_button_1.SubmitButton.view({
                    title: buttonText,
                    submit: successFunc,
                    submitting: this.ctrl.loading,
                    className: auth_component_style_1.CSS.button,
                    noAccent: true
                })
            ];
        },
        enumerable: false,
        configurable: true
    });
    return InviteAcceptComponent;
}(mithril_component_1.IMithrilComponent));
var InviteSuccessSSOComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InviteSuccessSSOComponent, _super);
    function InviteSuccessSSOComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        return _this;
    }
    Object.defineProperty(InviteSuccessSSOComponent.prototype, "nodes", {
        get: function () {
            return [
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_SSO_CREATION_SUCCESS)),
                submit_button_1.SubmitButton.view({
                    title: index_1.T.LOGIN,
                    submit: function () { return services_1.Services.SSO.login({ redirect_uri: window.location.origin }); },
                    className: auth_component_style_1.CSS.button,
                    noAccent: true
                })
            ];
        },
        enumerable: false,
        configurable: true
    });
    return InviteSuccessSSOComponent;
}(mithril_component_1.IMithrilComponent));
var InviteFailedSSOComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InviteFailedSSOComponent, _super);
    function InviteFailedSSOComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        return _this;
    }
    Object.defineProperty(InviteFailedSSOComponent.prototype, "nodes", {
        get: function () {
            var _this = this;
            return [
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_SSO_FAILED)),
                submit_button_1.SubmitButton.view({
                    title: index_1.T.TRY_AGAIN,
                    submit: function () { return services_1.Services.Route.go(page_1.IkePageName.acceptInvite, { inviteToken: _this.ctrl.inviteToken }); },
                    className: auth_component_style_1.CSS.button,
                    noAccent: true
                })
            ];
        },
        enumerable: false,
        configurable: true
    });
    return InviteFailedSSOComponent;
}(mithril_component_1.IMithrilComponent));
var InviteInvalidAccountComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InviteInvalidAccountComponent, _super);
    function InviteInvalidAccountComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        return _this;
    }
    Object.defineProperty(InviteInvalidAccountComponent.prototype, "nodes", {
        get: function () {
            return [
                (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_INVALID_ACCOUNT)),
                submit_button_1.SubmitButton.view({
                    title: index_1.T.LOGOUT,
                    submit: function () { return services_1.Services.SSO.logout(); },
                    className: auth_component_style_1.CSS.button,
                    noAccent: true
                })
            ];
        },
        enumerable: false,
        configurable: true
    });
    return InviteInvalidAccountComponent;
}(mithril_component_1.IMithrilComponent));
//# sourceMappingURL=accept.invite.js.map